var React = require('react');

function Users (props) {
    return React.createElement("svg",props,React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M12.454 19H1v-3.529c0-.992.593-1.887 1.51-2.268.929-.384 2.31-.748 4.217-.748 1.906 0 3.288.364 4.217.75.917.379 1.51 1.274 1.51 2.266V19zM6.727 10C8.535 10 10 8.535 10 6.727c0-1.807-1.465-3.273-3.273-3.273-1.807 0-3.272 1.466-3.272 3.273C3.455 8.535 4.92 10 6.727 10zM19 9.866c0-.494-.217-.965-.604-1.272-.592-.47-1.618-1.049-3.078-1.049-1.46 0-2.486.58-3.078 1.05-.387.306-.604.777-.604 1.27v.953H19v-.952zM15.318 5.09c1.13 0 2.045-.915 2.045-2.045S16.448 1 15.318 1s-2.045.916-2.045 2.045c0 1.13.915 2.046 2.045 2.046z"}));
}

Users.defaultProps = {"width":"20","height":"20","fill":"none","viewBox":"0 0 20 20","stroke":"#737680"};

module.exports = Users;

Users.default = Users;
